import {inject, injectable} from 'inversify';

import {BaseDomainFactory} from '../../../core/domain/Base/BaseDomain.factory';
import {ModelsRegistry} from '../../system/modelsRegistry/ModelsRegistry';
import {CouponModel} from './Coupon.model';

@injectable()
export class CouponFactory
  implements BaseDomainFactory<CouponModel, CouponModel.Props>
{
  constructor(
    @inject(ModelsRegistry)
    private readonly modelsRegistry: ModelsRegistry,
  ) {}

  create(props: CouponModel.Props): CouponModel {
    return this.modelsRegistry.put(new CouponModel(props));
  }
}
